import { TONE_CLASSES, toneAt } from '../analytics/chartTheme';

interface ReportFinding {
  insight: string;
  category: 'insight' | 'pain_point' | 'opportunity' | 'data_point';
}

interface InsightsGridProps {
  findings: ReportFinding[];
  /** Show at most this many findings. Omit to show all. */
  limit?: number;
}

/** Short label for a finding's category. */
function formatCategoryLabel(category: ReportFinding['category']): string {
  switch (category) {
    case 'insight':
      return 'Insight';
    case 'pain_point':
      return 'Pain point';
    case 'opportunity':
      return 'Opportunity';
    case 'data_point':
    default:
      return 'Data point';
  }
}

/** Key insights as toned cards, matching the Overview's card design. */
export function InsightsGrid({ findings, limit }: InsightsGridProps) {
  const shown = limit === undefined ? findings : findings.slice(0, limit);
  if (!shown.length) return null;
  return (
    <section aria-label="Key insights" className="flex flex-col gap-4">
      <h2 className="text-base font-semibold text-foreground">Key insights</h2>
      <div className={`grid grid-cols-1 gap-4 ${shown.length >= 3 ? 'md:grid-cols-3' : shown.length === 2 ? 'md:grid-cols-2' : ''}`}>
        {shown.map((finding, index) => (
          <article key={index} className={`${TONE_CLASSES[toneAt(index)]} flex flex-col gap-2 rounded-[20px] p-6`}>
            <span className="text-xs font-medium text-muted-foreground">{formatCategoryLabel(finding.category)}</span>
            <p className="text-[15px] font-medium leading-snug text-foreground">{finding.insight}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default InsightsGrid;
